module.exports = __webpack_public_path__ + "static/media/travelingbymoto2.5830ac8e.png";